module.exports = __webpack_public_path__ + "img/initials.7a03e776.svg";